import { render, staticRenderFns } from "./HirePurchase.vue?vue&type=template&id=520e35d4"
import script from "./HirePurchase.vue?vue&type=script&lang=js"
export * from "./HirePurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports